import axios from 'axios';

export const getSupportedItemTypes = async () => {
    const response = await axios.get(`/rescaling/itemTypes`);
    return response.data;
};

export const rescaleItem = async (itemId, scalingValue) => {
    const payload = {
        scalingValue,
    };

    const response = await axios.post(`/rescaling/${itemId}`, payload);

    return response.data;
};
